import { useMemo } from "react";
import { useReportSnapshot } from "../../../features/reportPdf/ReportSnapshotContext";
import { aggregateCampaignStatisticsTotals } from "../utils/aggregateCampaignStatisticsTotals";

const useGlobalReportDerivedMetrics = ({
  campaigns = {},
  statistics = {},
  previousPeriodStatistics = {},
  dispatch,
  hasExplicitRange = false,
}) => {
  const snapshot = useReportSnapshot();
  const totals = useMemo(
    () =>
      aggregateCampaignStatisticsTotals({
        campaigns,
        statistics,
        dispatch,
      }),
    [campaigns, dispatch, statistics]
  );

  const totalsLastPeriod = useMemo(() => {
    const previousCampaigns = previousPeriodStatistics?.campaigns || {};

    if (!hasExplicitRange || !Object.keys(previousCampaigns).length) {
      return null;
    }

    return aggregateCampaignStatisticsTotals({
      campaigns,
      statistics: previousPeriodStatistics,
      dispatch,
    });
  }, [campaigns, dispatch, hasExplicitRange, previousPeriodStatistics]);

  if (snapshot) {
    return {
      totals: snapshot.totals ?? totals,
      totalsLastPeriod: snapshot.totalsLastPeriod ?? null,
    };
  }

  return {
    totals,
    totalsLastPeriod,
  };
};

export default useGlobalReportDerivedMetrics;
